export enum TimerType {
	Section = 0,
	Break
}
